var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isEmptyCalendar
    ? _c(
        "div",
        [
          _setup.isExpress && _setup.filterType !== "telemed"
            ? [
                _setup.isMobile
                  ? _c(_setup.AppointmentButtonCallLpu, {
                      attrs: {
                        phone: _vm.lpuPhone,
                        "lpu-working-text": _vm.lpuWorkingText,
                      },
                    })
                  : _vm._e(),
              ]
            : _c(_setup.CalendarStub),
        ],
        2
      )
    : _c(
        "div",
        { class: _setup.isMobile ? "mx-n4" : "mr-n6" },
        [
          _c(_setup.AppointmentCalendar, {
            attrs: {
              "is-appointment-doctor": _vm.isWorkplace,
              "is-appointment-lpu": !_vm.isWorkplace,
              slots: _setup.calendarSlots,
              "padding-left": _setup.isMobile ? undefined : 0,
              "padding-right": _setup.isMobile ? undefined : 24,
              fog: _setup.isMobile ? false : "left",
              "appointment-type":
                _setup.filterType === "telemed" ? "" : _vm.appointmentType,
              "lpu-working-text": _vm.lpuWorkingText,
              "lpu-phone": _vm.lpuPhone,
            },
            on: { "calendar:time-choice": _setup.handleCalendarTimeChoice },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }